import React, { Component } from 'react';
import { Spin,Modal, Input,message, Alert,Button } from 'antd';
import EssaModal from "@/components/EssaModal/EssaModal";
import PropTypes from 'prop-types';
import Lang from "@components/Lang/Lang"
// import UploadImage from '../../common-antd/oneComponents/UploadImage/UploadImage';
import UploadImage from '@components/UploadFile/UploadImage/UploadImage';
import {isEmpty,symbolMoneyUtil,postHttpAction} from '@utils/utils';
import './popSetPulFillMent.less';

class PopSetFulfillment extends Component {
    static propTypes = {
        // flagBatch: PropTypes.bool,
        poItem: PropTypes.object,
    }
    static defaultProps = {
        // flagBatch: false,
        poItem:null,
    };
  constructor(props) {
    super(props);
    this.state = {
        isModalVisible: false,
        isBarcodeModalVisible: false,
        serviceItemList: [ // 包装选项配置数组
        ],
        barcodeRequireList:[],
        isPopoverVisible: false,
        shouldAutoOpenPopover: false, // 未打开过默认为true，关闭过再打开为false
        loading:false,
    };
      this.__getServerLanguage = __getServerLanguage;
  }
    pushBarcode(){
        let {barcodeRequireList=[]}= this.state;
        barcodeRequireList.push({
            productRequireNotCn: "", // 默认选择气泡膜
            fileList: [], // 存储上传的条码文件
        })
        const newList =[...barcodeRequireList]
        this.setState({
            barcodeRequireList: newList,
            showGreyAdd:true
        });
    }
    /*
    * 条码 行编
    * */
    handleBarcodeChange = (field,value,inx) => {
      let {barcodeRequireList=[]}= this.state;
      let newObj = barcodeRequireList[inx]||{};
      newObj[field] = value;
      // console.log("Barcode",newObj);
      const newList =[...barcodeRequireList]
      this.setState({ barcodeRequireList: newList });
    }
    /*
    * 其他要求 行编
    * */
    handleOtherChange(field,value){
        const {requireVO={}}= this.state;
        let newObj = {...requireVO};
            newObj[field] = value;
            // console.log("requireVO",requireVO);
        this.setState({ requireVO: newObj });
    }
    /*
    * 打开 商品条形码定制说明 弹窗
    * */
    handleOpenBarcodeModal = (flag=true) => {
        this.setState({ isBarcodeModalVisible: flag });
    };
    // 处理Popover显示/隐藏
    handlePopoverVisibleChange = (visible,setLocal) => {
        this.setState({ isPopoverVisible: visible });
        // 关闭泡泡时，记录到localStorage
        if (setLocal) {
            localStorage.setItem('hasOpenedPopover', 'true');
        }
    };

    loading(flag){
        this.setState({
            loading:flag
        })
    }
    /*
    * 打开 条形码定制 弹窗
    * */
    handleOpenModal = (flag=true) => {
        if(flag){
            const {barcodeRequireList,otherRequireList=[]} = this.props;
            let requireVO=otherRequireList&&otherRequireList.length>0?otherRequireList[0]:{};
            if(requireVO.productRequireFileList&&requireVO.productRequireFileList.length>0){
                requireVO.fileList = requireVO.productRequireFileList;
            }
            let list=[];
            if(barcodeRequireList&&barcodeRequireList.length>0){
                // list=[...barcodeRequireList]
                barcodeRequireList.forEach(bar=> {
                    let fileList = [];
                    if (bar.productRequireFileId){
                            fileList = [{
                                fileId: bar.productRequireFileId,
                                fileUrl: bar.productRequireFileUrl,
                                isBarcodeFile: bar.isBarcodeFile,
                            }];
                    }
                    list.push({
                        fileList:fileList,
                        // name:bar.realName+'.'+respModel.extend,
                        // fileName:bar.realName+'.'+respModel.extend, // 对接后端保存时用此字段
                        productRequireId:bar.productRequireId,
                        productRequireNotCn:bar.productRequireNotCn,
                    })
                })
            }else {
                list=[{
                    productRequireNotCn: "", // 默认选择气泡膜
                    fileList: [], // 存储上传的条码文件
                }];
            }

            this.setState({
                isModalVisible:flag,
                barcodeRequireList: list,
                requireVO:requireVO,
            },()=>{

            })
        }else {
            this.setState({
                requireVO:{},
                barcodeRequireList:[],
                serviceItemList:[],
                selectedPackage:{},
                // shoppingCartIds:[],
                isModalVisible: flag
            })
        }
    };
    /*
    * http://rap.essa.top:88/workspace/myWorkspace.do?projectId=84#8581
    * 保存
    * */
    handleConfirmSubmit = () => {
        // 处理确认提交逻辑
        const {poItem}=this.props;
        const {barcodeRequireList=[],requireVO={},} = this.state;
        let postReqVo = {
            productRequireNotCn:requireVO.productRequireNotCn||"",
        };
        if(requireVO.fileList&&requireVO.fileList.length>0&&requireVO.fileList[0].fileId){
            postReqVo["productRequireFileId"] = requireVO.fileList[0].fileId;
        }
        if(requireVO.productRequireId){
            postReqVo["productRequireId"] = requireVO.productRequireId;

        }
        let postBarcode = [];
        barcodeRequireList.forEach(bar=>{
            let barVo = {
                productRequireNotCn:bar.productRequireNotCn||"",
            };
            if(bar.fileList&&bar.fileList.length>0&&bar.fileList[0].fileId){
                barVo["productRequireFileId"] = bar.fileList[0].fileId;
            }
            if(bar.productRequireId){
                barVo["productRequireId"] = bar.productRequireId;

            }
            // 过滤：只有当有productRequireNotCn或者fileId时才放进postBarcode数组中
            if(barVo.productRequireNotCn || barVo.productRequireFileId){
                postBarcode.push(barVo);
            }
        })
        this.loading(true);
        const requireResultVO= {
            otherRequireList: (postReqVo.productRequireNotCn||postReqVo.productRequireFileId)?[postReqVo]:[],
            barcodeRequireList: postBarcode,
        }
        postHttpAction("/service/mg/sale/po/item/require/save-one", {
            poId: poItem&&poItem.poId||'',
            requireResultVO:requireResultVO,
            poItemId: poItem.id,
        },(res)=>{
            this.loading(false);
            this.handleOpenModal(false);
            if(res.success&&res.valid){
                message.success(Lang({id:'CaoZuoChengGong',default:'操作成功'}));
                if(this.props.refresh){
                    this.props.refresh()
                }
            }else{
                message.info(res.message||Lang({id:'CaoZuoShiBai',default:'操作失败'}));
            }
        });

    };

    deleteRow(inx){
        const {barcodeRequireList} = this.state;
        const newList = barcodeRequireList.filter((_, index) => index !== inx);
        this.setState({ barcodeRequireList: newList });
    }
    componentWillMount() {
    }
    render() {
    const {className,flagBatch,sku,children} = this.props;
    const {showGreyAdd=false, barcodeRequireList=[],isModalVisible, isBarcodeModalVisible,loading=false,requireVO={},isPopoverVisible } = this.state;
    return (<>
        {children?<div onClick={()=>this.handleOpenModal(true)}>{children}</div>:<div className={`${className?" "+className:""}`}>
            {sku&&sku.serviceCodeName?<span className={"flex-item-ver-center"}><i className={"icon-font icon-xinfeng mr_4"} />{sku.serviceCodeName}</span>:<span className={"flex-item-ver-center"}><i className={"icon-font icon-plus-add mr_4"} />{Lang({id:'BaoZhuangFuWu',default:'Fulfillment'})}</span>}
      </div>}
        {isModalVisible &&
            <Modal
                open={isModalVisible}
                closeIcon={<span></span>}
                destroyOnHidden={true}
                onCancel={()=>this.handleOpenModal(false)}
                onOk={()=>this.handleConfirmSubmit()}
                footer={null}
                wrapClassName={"pop-set-pull-fill-ment"}
                width={1200}>
                    <Spin spinning={loading}>
                        <div className="modal-footer">
                            {/* 底部提示 */}
                            <div className="black89 fw_700 font-18">
                                {Lang({id:'BaoZhuangFuWu',default:'额外服务'})}
                            </div>
                            <div>
                                <Button className="cancel-btn mr_12" onClick={()=>this.handleOpenModal(false)}>
                                    {Lang({id:'GuanBi',default:'关闭'})}
                                </Button>
                                <Button type="primary" onClick={()=>this.handleConfirmSubmit()}>
                                    {Lang({id:'QueDing',default:'确定'})}
                                </Button>
                            </div>
                        </div>
                        <div className={"mainSetting"}>
                            <Alert message={Lang({id:'KeHuDuiDingDanHuoDingDanZ2',
                                default:'客户对订单或订单中的任意商品有特殊要求，请清楚地写明。这些要求可能涉及商品颜色、指定款式、配件功能等方面。'})} type="warning" showIcon />
                            {/* 2. 条码定制 批量操作时隐藏*/}
                            {flagBatch?null:<div className="service-section">
                                <div className="section-title flex-item-ver-center">
                                    <span className="stepIcon step-blue"><i className="ri-barcode-line"></i></span>
                                    <span>{Lang({id:'TiaoMaDingZhi',default:'条码定制'})}</span>
                                    <div className="ml_10 font6A7282 flex-item-ver-center cursor-p" onClick={() => this.handlePopoverVisibleChange(true)}>
                                        <i className="icon iconfont icon-Vector1 mr_4 color-red2"></i>{Lang({id:'DingZhiTiaoMaShuoMing',default:'定制条码说明'})}
                                    </div>
                                </div>
                                <div className={`${barcodeRequireList.length>1?"":"flex-item"}`}>
                                    {barcodeRequireList.length>1?null:<div className="barcode-example mr_16 cursor-p" onClick={()=>this.handleOpenBarcodeModal()}>
                                        <img src="https://oss.essaone.com/062b0aca-5f62-49e3-bf70-be690d7b665d.jpeg" alt={Lang({id:'ShiLi',default:'示例'})} />
                                        <span className="example-label">{Lang({id:'ShiLi',default:'示例'})}</span>
                                    </div>}
                                    {barcodeRequireList.map((bar,inx)=><div className={"flex-1 barcode-section"} key={'bar_'+inx}>
                                        <div className="upload-btn mr_16">
                                            <UploadImage
                                                initValue={bar.fileList}
                                                onChange={(fileList)=>this.handleBarcodeChange('fileList',fileList,inx)}
                                                maxCount={1}
                                                placeholder={Lang({id:'ShangChuanTiaoMa',default:'上传条码'})}
                                                accept=".jpg,.jpeg,.png,.pdf,.gif"
                                                styleUpload=""
                                            />
                                        </div>
                                        <div className="input-group">
                                            <Input.TextArea
                                                value={bar.productRequireNotCn}
                                                onChange={(e)=>this.handleBarcodeChange('productRequireNotCn',e.target.value,inx)}
                                                placeholder={Lang({id:'ShuRuTiaoMa',default:'输入条码'})}
                                                rows={4}
                                                style={{ width: '350px',height: '80px' }}
                                            />
                                            {inx?<span className={"font-main2 cursor-p ml_8"} onClick={()=>this.deleteRow(inx)}>
                                                {Lang({id:'ShanChu',default:'删除'})}
                                                </span>:null}
                                        </div>
                                    </div>)}
                                </div>
                                {/* 一款多条码 */}
                                {showGreyAdd?<div className={"btnGrey mt_12"} onClick={()=>this.pushBarcode()}>{Lang({id:'TianJia',default:'添加'})}</div>:<div className={"btnPink mt_12"} onClick={()=>this.pushBarcode()}>
                                    <i className="ri-exchange-2-line mr_6"></i>{Lang({id:'YiKuanDuoTiaoMa',default:'SKU多条码'})}</div>}

                            </div>}
                            {/* 3. 其他要求 */}
                            <div className="service-section">
                                <div className="section-title">
                                    <span className="stepIcon stepOrange"><i className="ri-file-text-line"></i></span>
                                    <span>{this.__getServerLanguage("QiTaYaoQiu")}</span>
                                </div>
                                <div className="other-requirements flex-item-ver-center">
                                    <div className="upload-btn">
                                        {!loading?<UploadImage
                                            initValue={requireVO.fileList}
                                            onChange={(fileList)=>this.handleOtherChange('fileList',fileList)}
                                            maxCount={1}
                                            accept=".jpg,.jpeg,.png,.pdf"
                                            styleUpload=""
                                            placeholder={this.__getServerLanguage("TuPianShuoMing")}//{'图片说明'}
                                        />:null}
                                    </div>
                                    <div className={"flex-1 ml_12"}>
                                        <Input.TextArea placeholder={this.__getServerLanguage("QingShuRuTeShuCaoZuoZhiLi")}//"请输入特殊操作指令，例如：拆除吊牌、更换包装盒、放置卡片等..."
                                                        onChange={(e)=>this.handleOtherChange('productRequireNotCn',e.target.value)}
                                                        value={requireVO.productRequireNotCn}
                                                        style={{ height: '80px' }} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Spin>
        </Modal>}

        <EssaModal
            title={Lang({id:'TiaoMaDingZhiShuoMing',default:'条码定制说明'})}
            open={isPopoverVisible}
            onCancel={() => this.handlePopoverVisibleChange(false)}
            footer={
                <div style={{ textAlign: "right" }}>
                    <Button type="primary" onClick={() => this.handlePopoverVisibleChange(false)}>
                        {Lang({id:'GuanBi',default:'关闭'})}
                    </Button>
                </div>
            }
            width={700}
            centered
        >
            <div className={"popTips_Fulfillment"}>
                <div dangerouslySetInnerHTML={{ __html: Lang({id:'RuoNinXuYaoJiangCaiGouDeS',default:`<div><div class="mb_6">1.提供贴纸服务——在中国出货前贴好WB/OZON等电商平台的 SKU ID 条码，无需您自行处理。</div>
<div class="mb_6">2.您只需提供 ID 条码文件——在WB/OZON等电商平台的后台生成条码（PDF/图片/条码信息）并上传到 ESSAONE 平台。</div>
<div class="mb_6">3.ID条码与诚实标志码合成一张贴纸——如果有Fulfillment 服务，将会在产品包装与 Fulfillment 外包装各贴一张。</div>
<div class="mb_6">4. 到达俄罗斯仓库后，不再需要再一次制作贴纸，可直接进入WB/OZON等电商平台的仓库。</div>
<div class="mb_6">5. 注意：如果同一SKU不同颜色/款式对应不同条码（混色/混款），请写明每个条码对应的具体商品。</div></div>`})}} />
                <div className="fw_700 black89 font_14 mt_20 mb_8">{Lang({id:'QingGuanTieZhiYangLi',default:'清关贴纸样例'})}</div>
                <div className="barcode-example-full">
                    {/*<img src="https://oss.essaone.com/e05f32fb-d562-4dad-9238-ace8975d7d8d.jpg" alt="" />*/}
                    <img src="https://oss.essaone.com/aa434e88-c4ef-4467-8be8-cc4fdf2aca44.png"  alt=""  />
                </div>
            </div>
        </EssaModal>
        {/* 条码说明弹窗 - 使用antd Modal组件 */}
        <EssaModal
            title={Lang({id:'ShangPinTiaoXingMaDingZhi',default:'商品条形码定制说明'})}
            open={isBarcodeModalVisible}
            onCancel={()=>this.handleOpenBarcodeModal(false)}
            footer={null}
            width={500}
            className="barcode-modal">
            <p className="barcode-desc">{Lang({id:'DingZhiTiaoMaJiangTiHuanQ',default:'定制条码将替换清关贴纸上的原商品条码'})}</p>
            <div className="barcode-example-full">
                <img src="https://oss.essaone.com/37697bef-d1f2-4923-beef-78324910cfed.png" style={{ width: '100%', maxWidth: '100%' }} />
                {/*<img src="https://oss.essa.cn/aa434e88-c4ef-4467-8be8-cc4fdf2aca44.png" style={{ width: '100%', maxWidth: '100%' }} />*/}
            </div>
        </EssaModal>
    </>);
    }
}

export default PopSetFulfillment;